import {AsyncActionInput, AsyncActionService} from "../../../../services/process/processes/async-action/async-action";
import {RecordManager} from "../../../../services/record/record.manager";
import {Record} from "../../../../common/record/record.model";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {Field} from "../../../../common/record/field.model";

const ACTION_LOAD_FIELDS = 'export_excel_get_fields';
const BULK_ACTION_LOAD_FIELDS = `bulk-${ACTION_LOAD_FIELDS}`;

const ACTION_RUN_EXPORT = 'export_excel_create_background_job';
const BULK_ACTION_RUN_EXPORT = `bulk-${ACTION_RUN_EXPORT}`;

@Injectable()
export class ExportExcelModalService {
    constructor(
        private asyncAction: AsyncActionService,
        private recordManager: RecordManager,
    ) {
    }

    getRecord(module: string): Record {
        return this.recordManager.buildEmptyRecord(module);
    }

    runExport(data: AsyncActionInput) {
        data.action = ACTION_RUN_EXPORT;
        return this.asyncAction.run(BULK_ACTION_RUN_EXPORT, data)
            .pipe(map((process => process.data['redirect'])));
    }

    loadData(data: AsyncActionInput): Observable<Field[]> {
        data.action = ACTION_LOAD_FIELDS;
        return this.asyncAction.run(BULK_ACTION_LOAD_FIELDS, data)
            .pipe(
                map((process => process.data['fields'])),
            );
    }
}